import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@/components';
export default function PrintButton({
  disabled,
  otherParams,
  buttonName,
  onClick,
  className,
}: {
  disabled: boolean;
  otherParams?: any;
  buttonName?: string;
  className?: string;
  onClick?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Button
      color="primary"
      variant="outlined"
      disabled={disabled}
      className={className}
      onClick={() => {
        if (onClick) {
          onClick?.();
          return;
        }
        const path = new URL(decodeURIComponent(window.location.href));
        path.searchParams.set('print', 'true');
        if (otherParams && Object.keys(otherParams).length) {
          Object.keys(otherParams).forEach((key) => {
            path.searchParams.set(key, otherParams[key]);
          });
        }
        const parms = path.search.split('?')[1];
        window.open(
          `${path.origin}${path.pathname}?${encodeURIComponent(parms)}`,
          '_blank',
        );
      }}
      icon={<SvgIcon classa="print" />}
    >
      {buttonName || t('print')}
    </Button>
  );
}
